// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Xm2Hq","logo":"styles_logo__MPxP6","logo-devider":"styles_logo-devider__BNA8j","img":"styles_img__tDsBf","text-block":"styles_text-block__5uUHy"};